import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Img from 'gatsby-image';

export default function BlogCoverImage({image, label = null}) {
	return (
		<Figure>
			<Img fluid={image} />
			{label && <figcaption>{label}</figcaption>}
		</Figure>
	);
}

BlogCoverImage.propTypes = {
	// eslint-disable-next-line
	image: PropTypes.object.isRequired, // fluid image
	label: PropTypes.string
};

const Figure = styled.figure`
	display: block;
	margin-left: -1rem;
	margin-right: -1rem;

	> img {
		display: block;
		width: 100%;
		height: auto;
	}

	@media (min-width: 1300px) {
		border-radius: 0.5rem;
		overflow: hidden;
	}
`;
